import { render, staticRenderFns } from "./EmailOverrideModal.vue?vue&type=template&id=f95e83ca&scoped=true&"
import script from "./EmailOverrideModal.vue?vue&type=script&lang=js&"
export * from "./EmailOverrideModal.vue?vue&type=script&lang=js&"
import style0 from "./EmailOverrideModal.vue?vue&type=style&index=0&id=f95e83ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95e83ca",
  null
  
)

component.options.__file = "EmailOverrideModal.vue"
export default component.exports